import { Spin } from 'antd';
import React from 'react';

const LoadingPage = () => {
  return <Spin spinning></Spin>;
};

export default LoadingPage;
